// extracted by mini-css-extract-plugin
export var numpadContainer = "_md-1";
export var phoneButton = "_md-0";